/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Exclusive_Feature_Sunshine_TitleInputs */

const en_subscription_exclusive_feature_sunshine_title = /** @type {(inputs: Subscription_Exclusive_Feature_Sunshine_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Triple Focus Coin Rewards`)
};

const ar_subscription_exclusive_feature_sunshine_title = /** @type {(inputs: Subscription_Exclusive_Feature_Sunshine_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ضاعف مكافآت عملة التركيز ثلاث مرات`)
};

const de_subscription_exclusive_feature_sunshine_title = /** @type {(inputs: Subscription_Exclusive_Feature_Sunshine_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dreifach-Fokus-Münzen-Belohnungen`)
};

const es_subscription_exclusive_feature_sunshine_title = /** @type {(inputs: Subscription_Exclusive_Feature_Sunshine_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Triple recompensa de monedas de concentración`)
};

const fr_subscription_exclusive_feature_sunshine_title = /** @type {(inputs: Subscription_Exclusive_Feature_Sunshine_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Récompenses en pièces triplées`)
};

const it_subscription_exclusive_feature_sunshine_title = /** @type {(inputs: Subscription_Exclusive_Feature_Sunshine_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ricompense monete di concentrazione triple`)
};

const ja_subscription_exclusive_feature_sunshine_title = /** @type {(inputs: Subscription_Exclusive_Feature_Sunshine_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`獲得コインが3倍`)
};

const ko_subscription_exclusive_feature_sunshine_title = /** @type {(inputs: Subscription_Exclusive_Feature_Sunshine_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`포커스 코인 리워드 3배`)
};

const pt_br_subscription_exclusive_feature_sunshine_title = /** @type {(inputs: Subscription_Exclusive_Feature_Sunshine_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recompensas de foco com o triplo de moedas`)
};

const ru_subscription_exclusive_feature_sunshine_title = /** @type {(inputs: Subscription_Exclusive_Feature_Sunshine_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тройная награда в виде монет за фокусировку`)
};

const th_subscription_exclusive_feature_sunshine_title = /** @type {(inputs: Subscription_Exclusive_Feature_Sunshine_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รางวัลเหรียญการโฟกัสเพิ่มขึ้นสามเท่า`)
};

const tr_subscription_exclusive_feature_sunshine_title = /** @type {(inputs: Subscription_Exclusive_Feature_Sunshine_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Üç Kat Odaklanma Jeton Ödülleri`)
};

const zh_cn_subscription_exclusive_feature_sunshine_title = /** @type {(inputs: Subscription_Exclusive_Feature_Sunshine_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`专注金币奖励 3 倍`)
};

const zh_tw_subscription_exclusive_feature_sunshine_title = /** @type {(inputs: Subscription_Exclusive_Feature_Sunshine_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`專注金幣獎勵 3 倍`)
};

/**
* | output |
* | --- |
* | "Triple Focus Coin Rewards" |
*
* @param {Subscription_Exclusive_Feature_Sunshine_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_exclusive_feature_sunshine_title = /** @type {((inputs?: Subscription_Exclusive_Feature_Sunshine_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Exclusive_Feature_Sunshine_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_exclusive_feature_sunshine_title(inputs)
	if (locale === "ar") return ar_subscription_exclusive_feature_sunshine_title(inputs)
	if (locale === "de") return de_subscription_exclusive_feature_sunshine_title(inputs)
	if (locale === "es") return es_subscription_exclusive_feature_sunshine_title(inputs)
	if (locale === "fr") return fr_subscription_exclusive_feature_sunshine_title(inputs)
	if (locale === "it") return it_subscription_exclusive_feature_sunshine_title(inputs)
	if (locale === "ja") return ja_subscription_exclusive_feature_sunshine_title(inputs)
	if (locale === "ko") return ko_subscription_exclusive_feature_sunshine_title(inputs)
	if (locale === "pt_br") return pt_br_subscription_exclusive_feature_sunshine_title(inputs)
	if (locale === "ru") return ru_subscription_exclusive_feature_sunshine_title(inputs)
	if (locale === "th") return th_subscription_exclusive_feature_sunshine_title(inputs)
	if (locale === "tr") return tr_subscription_exclusive_feature_sunshine_title(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_exclusive_feature_sunshine_title(inputs)
	return zh_tw_subscription_exclusive_feature_sunshine_title(inputs)
});